const slidersHero = document.querySelectorAll('.hero-slider');
const slidersReal = document.querySelectorAll('.block-realisations-list');
const slidersTemoignages = document.querySelectorAll('.block-temoignages-list');

if (
  slidersHero.length > 0 ||
  slidersReal.length > 0 ||
  slidersTemoignages.length > 0
) {
  import('slick-carousel').then(({ default: slick }) => {
    if (slidersHero.length > 0) {
      slidersHero.forEach(slider => {
        $(slider).slick({
          infinite: true,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          dots: false,
          fadeSpeed: 1000,
        });
      });
    }

    if (slidersReal.length > 0) {
      slidersReal.forEach(slider => {
        let slickSlider = $(slider).slick({
          lazyLoad: 'ondemand',
          infinite: true,
          initialSlide: 3,
          slidesToShow: 5,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          dots: false,
          fadeSpeed: 1000,
          centerMode: true,
          centerPadding: '60px',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 4,
                centerPadding: '60px',
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                centerPadding: '45px',
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                centerPadding: '30px',
              },
            },
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1,
                centerPadding: '15px',
              },
            },
          ],
        });

        slickSlider.on('afterChange', () => {
          window.lazyLoadInstance.update();
        });

        $(slider)
          .parent()
          .find('.block-realisations-arrows .prev')
          .on('click', () => {
            $(slider).slick('slickPrev');
          });

        $(slider)
          .parent()
          .find('.block-realisations-arrows .next')
          .on('click', () => {
            $(slider).slick('slickNext');
          });
      });
    }

    if (slidersTemoignages.length > 0) {
      slidersTemoignages.forEach(slider => {
        let slickSlider = $(slider).slick({
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          dots: false,
          fadeSpeed: 1000,
        });

        $(slider)
          .parent()
          .parent()
          .find('.block-temoignages-arrows .prev')
          .on('click', () => {
            console.log('slickPrev');
            $(slider).slick('slickPrev');
          });

        $(slider)
          .parent()
          .parent()
          .find('.block-temoignages-arrows .next')
          .on('click', () => {
            console.log('slickNext');
            $(slider).slick('slickNext');
          });
      });
    }
  });
}
